import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IChecklistAnswerType } from '../interfaces/IChecklistAnswerType';

export async function fetchChecklistAnswerTypes(): Promise<IChecklistAnswerType[]> {
  return apiGet<IChecklistAnswerType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/checklist-answer-types`,
  );
}
